import BaseModelAPI from '../BaseModelAPI';

export default class ReportIncomingList extends BaseModelAPI {

	static entity = 'newreport1999list'
	static entityName = 'reportincoming';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
